/** Featured "Tu zacznij!" challenge — linked from main menu, hidden from listing/search. */
export const START_HERE_CHALLENGE_ID = '9e7147a7-fa63-49e3-8c4a-0b7ab9ccec19';
